import DiscoverLoyaltyProducts from './DiscoverLoyaltyProducts'

export default DiscoverLoyaltyProducts
